import type {
  FilterPresetRequestBody,
  FilterPresetResponseBody,
} from '@ipfabric/utils';
import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';
import { selectFilterPreset } from 'components/ApiTable/model/commands/selectFilterPreset';
import { selectTableId } from 'components/ApiTable/model/selectors/selectTableId';

interface SaveFilterCommand {
  name: string;
}

export const saveFilter: ApiTableCommandFactory<SaveFilterCommand> =
  (cmdContext, dispatch) => async (command) => {
    const { advancedFilter } = cmdContext.getState();
    const tableId = selectTableId(cmdContext.getState());

    if (!advancedFilter.filters) {
      return;
    }

    const preset = await cmdContext.api.request<
      FilterPresetResponseBody,
      FilterPresetRequestBody
    >({
      url: '/filters',
      method: 'POST',
      data: {
        name: command.name,
        filter: advancedFilter.filters,
        webEndpoint: tableId,
      },
    });

    dispatch(selectFilterPreset, { preset });
  };
